export default Object.freeze({
  Pdf: 1,
  Pptx: 2,
});

export const ReportExportFormatString = Object.freeze({
  pdf: 'pdf',
  pptx: 'pptx',
});
